import { render, staticRenderFns } from "./BaseResultsPanel.vue?vue&type=template&id=5a21f58d&scoped=true&"
import script from "./BaseResultsPanel.vue?vue&type=script&lang=js&"
export * from "./BaseResultsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a21f58d",
  null
  
)

export default component.exports